'use strict';

var noop = function noop() {};

var loadJS = require('load.js').js;

module.exports = window.olark || loadOlark();

function loadOlark() {
  var url = 'static.olark.com/jsclient/loader.js';
  loadJS("//".concat(url), noop);

  var item = window.olark = function () {
    k.s.push(arguments);
    k.t.push(+new Date());
  };

  item.extend = function (i, src) {
    item('extend', i, src);
  };

  item.identify = function (o) {
    item('identify', k.i = o);
  };

  item.configure = function (key, callback) {
    item('configure', key, callback);
    k.c[key] = callback;
  };

  var k = item._ = {
    s: [],
    t: [+new Date()],
    c: {},
    l: url
  };
  return item;
}